import { DataTable } from "capitalrx-components";
import React from "react";
import { useDispatch, useSelector } from "react-redux";

import { drugSearchActions, drugSelectActions } from "@/App/actions";
import { RootState } from "@/App/reducers";
import { DrugTypes } from "@/types";
import { DrugResult } from "@/types/appTypes/drug";

import tableHeaders from "./ResultsTableHeaders";

import { logEvent, ANALYTIC_EVENTS } from "@/App/utils/analytics";

const FORM_NAME = "TestClaimDrugSearchForm";

const ResultsTable: React.FC = () => {
  const dispatch = useDispatch();
  const { searchForDrug } = drugSearchActions;
  const { selectDrugAction } = drugSelectActions;

  const { results, result_count } = useSelector((state: RootState) => state.drug.drugSearchResults);
  const { DrugSearchForm } = useSelector((state: RootState) => state.form);
  const { drugSearchOptions } = useSelector((state: RootState) => state.drug);

  let submitting = false;
  if (DrugSearchForm && DrugSearchForm.submitting) {
    submitting = DrugSearchForm.submitting;
  }

  const handleUpdate = (data: DrugTypes.DrugSearchOptions): void => {
    // check for submitted form components to add to search options
    if (drugSearchOptions.drug_name) {
      data.drug_name = drugSearchOptions.drug_name;
    }

    dispatch(
      searchForDrug({
        data,
        formName: FORM_NAME,
      }),
    );
  };

  const handleAddDrug = (drug: DrugResult): void => {
    dispatch(selectDrugAction(drug));

    logEvent(ANALYTIC_EVENTS.TEST_CLAIM_DRUG.add);
  };

  const tableResultHeader = result_count + " drug(s) found:";

  const drugData = results.map(({ drug }) => {
    const drugInfo = {
      ndc: drug.ndc,
      drug_name: drug.drug_name,
      dosage_form: drug.dosage_form,
      dosage: drug.dosage,
      package_size: drug.package_size,
      package_size_unit_of_measure: drug.package_size_unit_of_measure,
      repackaged_code: drug.repackaged_code,
    };

    return drugInfo;
  });

  let resultsTable = null;
  if (result_count) {
    resultsTable = (
      <>
        <div className="table-section-result-header">{tableResultHeader}</div>
        <DataTable
          data={drugData}
          headers={tableHeaders}
          onClick={handleAddDrug}
          queryOptions={drugSearchOptions}
          isLoading={submitting}
          resultsTotalCount={result_count}
          handleUpdateRequest={handleUpdate}
          searchIsEnabled={false}
          className="search-list"
          ableToSort
        />
      </>
    );
  }

  return resultsTable;
};

export default ResultsTable;
